import clsx from 'clsx';
import { TestId } from '../../enums/test';
import { DotProps } from './index.types';

const variantClassMap = {
    neutral: ['bg-charcoal', 'border-charcoal-400', 'bg-charcoal-400'],
    success: ['bg-green-50', 'border-green-500', 'bg-green-500'],
    warn: ['bg-yellow-50', 'border-yellow-700', 'bg-yellow-700'],
};

function Dot({ variant = 'neutral' }: DotProps) {
    const className = variantClassMap[variant];

    return (
        <div
            className={clsx('flex justify-center items-center w-30 h-30 rounded-20 z-10', className[0])}
            data-testid={TestId.DOT}
        >
            <div className={clsx('flex justify-center items-center p-5 w-20 h-20 border rounded-20', className[1])}>
                <div className={clsx('shrink-0 w-10 h-10 rounded-20', className[2])} />
            </div>
        </div>
    );
}

export default Dot;
